import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import { getZoomJwtToken } from '../../organizations/actions/zoom-actions';
import { Box, Fade, Flex, Text } from '@chakra-ui/react';
import DsrDeleteZoomLinkLink from './DsrDeleteZoomLinkLink';
import '../../global/styles/animations.scss'
import { SiZoom } from 'react-icons/si';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

function LaunchZoomCallButton({
  //Parent Component
  dsrId,
  isPagePreviewMode,
  handleOpenSignupOrLoginModal,
  // Actions
  getZoomJwtToken,
  // Redux
  isMobileView,
  isPublicDsrEnvironment,
  isDsrAdmin,
  dsrStatusRedux,
  dsrZoomLinkActive,
  zoomCallDisplayStatus,
  // generatedZoomJwtTokenMetadata,
  zoomCallIsLive,
  zoomCallCurrentlyActive
}) {

  const [zoomIsLoading, setZoomIsLoading] = useState(false)
  const location = useLocation()
  const isDraftMode = (dsrStatusRedux === "draft" || dsrStatusRedux === "reverted-draft") ? true : false;

  useEffect(() => {
    if (zoomCallIsLive === false) {
      setZoomIsLoading(false)
    }
  }, [zoomCallIsLive])


  const handleLaunchZoomCall = () => {
    getZoomJwtToken({ dsrId })
    setZoomIsLoading(true)
  }

  const renderZoomMeetingDisplay = () => {
    return (
      <Flex w='100%' justify='flex-start' align='center' border='1px solid' borderColor='gray.300' rounded='0.5em' p='0.5em'>

        <Flex w='100%' justify='space-between' align='center' direction={isMobileView && 'column'}>
          <Flex w='100%' align={isMobileView ? "center" : 'flex-start'} justify={isMobileView ? 'center' : 'flex-start'} direction={isMobileView && 'column'} mb={isMobileView && '0.5em'}>
            <Box p='0.5em' rounded='0.25em' border='1px solid' borderColor='gray.100'>
              <Box as={SiZoom} boxSize='2em' color='brandDark.500' />
            </Box>

            <Box pl='0.5em' pt='0.25em'>
              {!isMobileView && <Box fontSize='0.5em' letterSpacing={'1px'} fontWeight='700' color='brandDark.500'>STATUS</Box>}
              <Flex fontSize='0.75em' align='center' justify={isMobileView && 'center'} gap={2} my="0.25em">
                <span class={zoomCallCurrentlyActive ? "blinking_green_dot" : "static_grey_dot"} />
                <Fade in={true} width='100%'>
                  <Text color='gray.500'>{zoomCallDisplayStatus ? zoomCallDisplayStatus : 'Not started'}</Text>
                </Fade>
                  
              </Flex>
            </Box>
          </Flex>
          {!zoomCallIsLive &&
              <LaunchdeckButton 
              w={isMobileView && '100%'}
              bg='brand.500' color='white' border='1px dotted' fontSize='0.75em'
                loadingLogic={zoomIsLoading}
                onClick={isPublicDsrEnvironment ? handleOpenSignupOrLoginModal : handleLaunchZoomCall} label={zoomCallDisplayStatus==="Left meeting" ? 'Rejoin' : 'Join'} />
     
          }
        </Flex>
      </Flex>
    )



  }

  if (dsrZoomLinkActive === true) {
    const isLiveEdit = (location.pathname.startsWith("/edit")) ? true : false;
    
    return (
      <Flex w='100%' justify='center'>

        {
          (isDraftMode || isLiveEdit)
            ?
            <Flex direction='column' justify='center' align='center'>
              <LaunchdeckButton bg='brandDark.500' color='white' cursor='default' dummy={true} px='2em' w={["100%", "100%", "auto", "auto"]}
                fontSize='0.8em' label='Zoom Meeting activated' />
              {isPagePreviewMode ?
                <Flex mt='0.5em' color='gray.500' w='100%' fontSize='0.7em' textAlign='center'>
                  Currently in Preview mode • Joining details provided when Room is published
                </Flex> : isDsrAdmin ? <DsrDeleteZoomLinkLink dsrId={dsrId} /> : null}
            </Flex> :
            <>
              {!zoomCallIsLive && renderZoomMeetingDisplay()}
            </>
        }
      </Flex>
    )
  } else {
    return null
  }

};



const mapStateToProps = (state) => ({
  isMobileView: state.mobileViewMode.isMobileView,
  isPublicDsrEnvironment: state.publicDsrEnvironment.publicDsrEnv,
  dsrZoomLinkActive: state.dsrZoomLinkActive.results,
  dsrStatusRedux: state.dsrStatus.status,
  isDsrAdmin: state.dsrAdmin.isDsrAdmin,
  zoomCallIsLive: state.zoomCallInSession.isLive,
  zoomCallCurrentlyActive: state.zoomCallCurrentlyActive.activeDsrZoomCall,
  zoomCallDisplayStatus:state.zoomCallDisplayStatus.callStatus
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getZoomJwtToken
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LaunchZoomCallButton));
